import { UserDefinedInformationWindowKinds } from "./UserDefinedInformationWindowKinds";
import { IUserDefinedItemSelectBehavior } from "./IUserDefinedItemSelectBehavior";

export class UserDefinedItemSelectBehavior {
  constructor(
    public windowKind: UserDefinedInformationWindowKinds,
    public shouldSelectRow: boolean,
  ) {
  }
  
  clone(): UserDefinedItemSelectBehavior {
    return new UserDefinedItemSelectBehavior(this.windowKind, this.shouldSelectRow);
  }

  static from(source: IUserDefinedItemSelectBehavior): UserDefinedItemSelectBehavior {
    return new UserDefinedItemSelectBehavior(source.windowKind, source.shouldSelectRow);
  }

  static to(source: UserDefinedItemSelectBehavior): IUserDefinedItemSelectBehavior {
    return {
      windowKind: source.windowKind,
      shouldSelectRow: source.shouldSelectRow,
    };
  }
}
